export const translations = {
  it: {
    // Attract Screen
    tapToStart: "TOCCA PER INIZIARE",
    highScores: "CLASSIFICA",
    
    // Form
    formSubtitle: "Inserisci i tuoi dati per ottenere il Gettone Virtuale",
    nome: "Nome e Cognome",
    azienda: "Azienda",
    email: "Email",
    telefono: "Telefono",
    citta: "Città",
    cap: "CAP",
    submit: "OTTIENI IL GETTONE VIRTUALE!",
    privacyRequired: "Devi accettare la privacy policy per continuare",
    errors: {
      required: "Campo obbligatorio",
      invalidEmail: "Email non valida",
      invalidPhone: "Numero non valido"
    },
    
    // Game
    score: "PUNTI",
    time: "TEMPO",
    oneUp: "1UP",
    
    // End Screen
    gameOver: "GAME OVER",
    deliveryComplete: "CONSEGNA COMPLETATA!",
    yourScore: "IL TUO PUNTEGGIO",
    enterInitials: "INSERISCI LE TUE INIZIALI",
    newGameIn: "Nuova partita in",
    
    // Admin
    admin: {
      title: "PANNELLO ADMIN",
      settings: "Impostazioni",
      sprites: "Sprites",
      audio: "Audio",
      leads: "Utenti & Lead",
      ranking: "Classifica",
      reset: "Reset Fiera",
      save: "Salva",
      cancel: "Annulla",
      confirm: "Conferma",
      delete: "Elimina",
      export: "Esporta CSV",
      resetConfirm: "Digita RESET per confermare",
      pinPrompt: "Inserisci PIN Admin",
      uploadSprite: "Carica Sprite",
      uploadAudio: "Carica Audio",
      preview: "Anteprima",
      gameDuration: "Durata partita (s)",
      powerupDuration: "Durata power-up (s)",
      playerSpeed: "Velocità player (px/s)",
      inactivityTimeout: "Timer inattività (s)",
      endscreenTimeout: "Timer end screen (s)",
      defaultLanguage: "Lingua default",
      adminPin: "PIN Admin",
      formTitleIt: "Titolo form IT",
      formTitleEn: "Titolo form EN",
      tier1: "Fascia 1",
      tier2: "Fascia 2",
      tier3: "Fascia 3",
      threshold: "Soglia",
      titleIt: "Titolo IT",
      titleEn: "Titolo EN",
      gameoverTextIt: "Testo game over IT",
      gameoverTextEn: "Testo game over EN",
      timeoutTextIt: "Testo tempo scaduto IT",
      timeoutTextEn: "Testo tempo scaduto EN",
      emailjs: "Configurazione EmailJS",
      colors: "Colori"
    }
  },
  en: {
    // Attract Screen
    tapToStart: "TAP TO START",
    highScores: "HIGH SCORES",
    
    // Form
    formSubtitle: "Enter your details to get the Virtual Token",
    nome: "Full Name",
    azienda: "Company",
    email: "Email",
    telefono: "Phone",
    citta: "City",
    cap: "Postal Code",
    submit: "GET YOUR VIRTUAL TOKEN!",
    privacyRequired: "You must accept the privacy policy to continue",
    errors: {
      required: "Required field",
      invalidEmail: "Invalid email",
      invalidPhone: "Invalid phone number"
    },
    
    // Game
    score: "SCORE",
    time: "TIME",
    oneUp: "1UP",
    
    // End Screen
    gameOver: "GAME OVER",
    deliveryComplete: "DELIVERY COMPLETE!",
    yourScore: "YOUR SCORE",
    enterInitials: "ENTER YOUR INITIALS",
    newGameIn: "New game in",
    
    // Admin
    admin: {
      title: "ADMIN PANEL",
      settings: "Settings",
      sprites: "Sprites",
      audio: "Audio",
      leads: "Users & Leads",
      ranking: "Ranking",
      reset: "Fair Reset",
      save: "Save",
      cancel: "Cancel",
      confirm: "Confirm",
      delete: "Delete",
      export: "Export CSV",
      resetConfirm: "Type RESET to confirm",
      pinPrompt: "Enter Admin PIN",
      uploadSprite: "Upload Sprite",
      uploadAudio: "Upload Audio",
      preview: "Preview",
      gameDuration: "Game duration (s)",
      powerupDuration: "Power-up duration (s)",
      playerSpeed: "Player speed (px/s)",
      inactivityTimeout: "Inactivity timeout (s)",
      endscreenTimeout: "End screen timeout (s)",
      defaultLanguage: "Default language",
      adminPin: "Admin PIN",
      formTitleIt: "Form title IT",
      formTitleEn: "Form title EN",
      tier1: "Tier 1",
      tier2: "Tier 2",
      tier3: "Tier 3",
      threshold: "Threshold",
      titleIt: "Title IT",
      titleEn: "Title EN",
      gameoverTextIt: "Game over text IT",
      gameoverTextEn: "Game over text EN",
      timeoutTextIt: "Timeout text IT",
      timeoutTextEn: "Timeout text EN",
      emailjs: "EmailJS Configuration",
      colors: "Colors"
    }
  }
};

export const t = (key, lang = 'it') => {
  const keys = key.split('.');
  let value = translations[lang];
  for (const k of keys) {
    value = value?.[k];
  }
  return value || key;
};
